import { render, staticRenderFns } from "./ActivityChangeComponent.vue?vue&type=template&id=b11dd59e"
import script from "./ActivityChangeComponent.vue?vue&type=script&lang=js"
export * from "./ActivityChangeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports